module.exports = __webpack_public_path__ + "static/media/grunt.471cea98.svg";